module.exports = __webpack_public_path__ + "static/media/swiftlogo.f8016922.png";